export enum Payment_Reference_Type {
	ISO11649 = 'ISO11649',
    OGM = 'OGM',
    PRIMARY_INVOICE = 'PRIMARY_INVOICE',
    PLAIN_ACCOUNT_ID = 'PLAIN_ACCOUNT_ID',
    ACCOUNT_ID = 'ACCOUNT_ID'
}
